/* eslint-disable react/no-array-index-key */
/* eslint-disable react/no-unused-state */
import React, { Component } from 'react';
import { Translate, I18n } from 'react-redux-i18n';
import { connect } from 'react-redux';

import Table from '../table/table';
import TableRegisterButton from '../table/registerButton';
import PlacesAction from '../../app/store/actions/places';
import ModalComponent from '../modal';

import { history } from '../../routers/AppRouter';
import ROUTES from '../../data/routes';

class PlacesPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      limit: 20,
      page: 1,
      search: '',
      orderBy: 'ASC',
      field: 'id',
      showModal: false,
      show: false,
    };
  }

  componentDidMount() {
    this.searchPlace();
  }

  updateValues = async (search = '', page = 1) => {
    await this.setState({ search, page });
    await this.searchPlace();
  }

  searchPlace = async () => {
    const {
      search, page, limit, orderBy, field = '',
    } = this.state;
    const skip = (page - 1) * limit;
    await this.props.searchItems(limit, skip, search, false, orderBy, field);
  }

  sortTable = async (field, orderBy) => {
    await this.setState({ orderBy, field });
    await this.searchPlace();
  }

  deletePlaceModal = async (placeId) => {
    await this.setState({ selectItemToDelete: placeId, showModal: true });
  }

  deletePlace = async () => {
    const { selectItemToDelete } = this.state;

    if (selectItemToDelete) {
      await this.props.deletePlace(selectItemToDelete);
      await this.setState({ selectItemToDelete: undefined, showModal: false });
      await this.searchPlace();
      this.deleteNotification();
    }
  }

  deleteNotification = () => {
    this.setState({ show: true });
    setTimeout(() => { this.setState({ show: false }); }, 5000);
  }

  render() {
    const { limit, page, showModal } = this.state;
    const { places = [] } = this.props;

    const tableHeader = [
      { key: 'codeState', value: I18n.t('state') },
      { key: 'codePlace', value: I18n.t('place') },
      { key: 'codeDeposit', value: I18n.t('deposit') },
      { key: 'codeBu', value: I18n.t('bu') },
      { key: 'action', value: I18n.t('action') },
    ];
    const tableData = places.length && places[0].rows.map((row, index) => {
      const { crmTag, id, city } = places[1].find(st => st.id === row.codePlace);
      const codeDeposit = row.codeDeposit || (places[3][0] && places[3][0].find(dep => dep.value === row.codeDeposit).description) || '';
      const bu = places[2] && places[2].find(bu => bu.id === row.codeBu);
      const codeBuDefault = bu ? bu.description : '';
      const stateName = places[2].find(st => st.crmTag === row.codeState);

      return ({
        key: row.id,
        id: row.id,
        codeState: row.location.state || stateName || '',
        codeBu: row.codeBu ? codeBuDefault : '',
        codeDeposit: codeDeposit ? codeDeposit : '',
        codePlace: crmTag || `${city}_${id}`,
        action: (
          <div
            key={`${row.id}_${index}`}
            className="btn-group"
            role="group"
            aria-label="Button group with nested dropdown"
          >
            <div className="btn-group" role="group">
              <button
                id="btnGroupDrop1"
                type="button"
                className="btn btn-secondary dropdown-toggle"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
              >
                <Translate value="action" />
              </button>
              <div className="dropdown-menu" aria-labelledby="btnGroupDrop1">
                <button
                  type="button"
                  className="dropdown-item dropdown-table"
                  onClick={() => history.push({
                    pathname: ROUTES.PARAMETERS_PLACES_FORM,
                    screenComming: 'parameters',
                    search: `?id=${row.id}`,
                  })}
                >
                  <Translate value="edit" />
                </button>
                <button
                  type="button"
                  className="dropdown-item dropdown-table"
                  onClick={() => this.deletePlaceModal(row.id)}
                >
                  <Translate value="delete" />
                </button>
              </div>
            </div>
          </div >
        ),
      });
    });

    const tableButtons = (
      <React.Fragment>
        <TableRegisterButton route={{ pathname: ROUTES.PARAMETERS_PLACES_FORM, screenComming: 'parameters' }} />
      </React.Fragment>
    );

    return (
      <div className="main-div-tables">
        <ModalComponent
          title={I18n.t('delete')}
          body={I18n.t('placeDelete')}
          visible={showModal}
          closeModal={() => this.setState({ showModal: false })}
          titleOkButtoon={I18n.t('confirm')}
          size={{ width: '300px', height: '170px' }}
          showButtons
          showCancel
          confirmModal={this.deletePlace}
        />

        {
          places.length && (
            <Table
              title={I18n.t('places')}
              buttons={tableButtons}
              header={tableHeader}
              lines={tableData}
              page={page}
              perPage={limit}
              count={places[0] && places[0].count}
              searchItems={this.updateValues}
              showItemsCount
              sortTable={this.sortTable}
            />
          )
        }
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  searchItems: (limit, skip, search, force, order, field) => dispatch(
    PlacesAction.getPlaces(limit, skip, search, force, order, field),
  ),
  deletePlace: id => dispatch(PlacesAction.deletePlace(id)),
});

const mapStateToProps = state => ({
  places: state.places && state.places.places,
});

export default connect(mapStateToProps, mapDispatchToProps)(PlacesPage);
